/**
 * @class SmartPurgeRule
 */
export default class SmartPurgeRule {
    /**
     * @param {Number}  id
     * @param {Number}  index
     * @param {Number}  volume
     * @param {Number}  minDispensedVolume
     * @param {Boolean} excludePurge
     * @param {String}  note
     * @param {Number}  priority
     */
    constructor(id, index, volume, minDispensedVolume, excludePurge, note, priority) {
        this._id = id;
        this._index = index;
        this._volume = volume;
        this._minDispensedVolume = minDispensedVolume;
        this._excludePurge = excludePurge;
        this._note = note;
        this._priority = priority;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - SmartPurgeRule");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get index() {
        return this._index;
    }

    /**
     * @param {Number} index
     */
    set index(index) {
        this._index = index;
    }

    /**
     * @return {Number}
     */
    get volume() {
        return this._volume;
    }

    /**
     * @param {Number} volume
     */
    set volume(volume) {
        this._volume = volume;
    }

    /**
     * @return {Number}
     */
    get minDispensedVolume() {
        return this._minDispensedVolume;
    }

    /**
     * @param {Number} minDispensedVolume
     */
    set minDispensedVolume(minDispensedVolume) {
        this._minDispensedVolume = minDispensedVolume;
    }

    /**
     * @return {Boolean}
     */
    get excludePurge() {
        return this._excludePurge;
    }

    /**
     * @param {Boolean} excludePurge
     */
    set excludePurge(excludePurge) {
        this._excludePurge = excludePurge;
    }

    /**
     * @return {String}
     */
    get note() {
        return this._note;
    }

    /**
     * @param {String} note
     */
    set note(note) {
        this._note = note;
    }

    /**
     * @return {Number}
     */
    get priority() {
        return this._priority;
    }

    /**
     * @param {Number} priority
     */
    set priority(priority) {
        this._priority = priority;
    }

    /**
     * @return {String}
     */
    toString() {
        return "SmartPurgeRule (" + this._id + ")";
    }

    /**
     * @return {SmartPurgeRule}
     */
    clone = () => {
        return new SmartPurgeRule(
            this._id,
            this._index,
            this._volume,
            this._minDispensedVolume,
            this._excludePurge,
            this._note,
            this._priority
        );
    };
}
